import 'isomorphic-fetch';
import { camelizeKeys } from 'humps';
import { url } from '../configs/';
const {
} = url;

export default function fetchData(fullUrl, userOptions) {
  const options = userOptions || {};
  options.credentials = 'include';

  return fetch(fullUrl, options)
  .then(response => {
    const contentType = response.headers.get('content-type');
    if (contentType.indexOf('json') !== -1) {
      return response.json().then(json => ({ json, response }));
    }

    if (contentType.indexOf('application/octet-stream') !== -1) {
      return response.blob().then(blob => {
        return { json: { data: blob }, response };
      });
    }
    return response.text().then(text => {
      return { json: { data: text }, response };
    });
  })
  .then(({ json, response }) => {
    const contentType = response.headers.get('content-type');
    if (contentType.indexOf('application/octet-stream') !== -1) {
      return json;
    }

    const camelizedJson = camelizeKeys(json);
    if (typeof(camelizedJson.error) !== 'undefined') {
      return Promise.reject({
        'status': camelizedJson.error.status,
        'message': camelizedJson.error.detail,
      });
    }

    if (!response.ok) {
      return Promise.reject({
        'status': response.status,
        'message': response.statusText,
      });
    }
    return camelizedJson;
  });
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/utils/api.js
 **/